import dispatcher from '../dispatcher';
import basicTransitionDecorator from '../router/transitions/basic-transition.decorator';
import menuTransitionDecorator from '../router/transitions/menu-transition.decorator';
import mainTransitionDecorator from '../router/transitions/main-transition.decorator';
// import scrollStore from '../scroll/scroll.store';
// import * as utils from '../utils';
// import TweenMax from '../../libs/TweenMax';
// import * as THREE from '/src/assets/scripts/libs/three-r97/three.module';

var elementProto = Object.create(HTMLElement.prototype);

// для копирования элемента.
// если при анимации какой-то элемент должен остаться на экране.

var _copyElement = function(el, data) {
	var fake = document.createElement('div');
	var styles = getComputedStyle(el);
	var container = this._inner ? this._inner : this;
	var offset, t, l;

	if (data.hide) {
		el.style.visibility = 'hidden';
	}

	fake.innerHTML = el.innerHTML;

	offset = el.getBoundingClientRect();
	t = offset.top;
	l = offset.left;

	fake.style.position = 'fixed';
	fake.style.left = l + 'px';
	fake.style.top = t + 'px';
	fake.classList.add('fake');

	if (data.class) {
		fake.classList.add(data.class);
	}

	fake.style.fontFamily = styles.fontFamily;
	fake.style.fontSize = styles.fontSize;
	fake.style.fontWeight = styles.fontWeight;
	fake.style.color = data.color || styles.color;
	fake.style.textTransform = styles.textTransform;
	fake.style.letterSpacing = styles.letterSpacing;
	fake.style.lineHeight = styles.lineHeight;

	// для затухающей анимации

	// setTimeout(function() {
	// 	fake.classList.add('fake-animate');
	// 	setTimeout(function() {
	// 		fake.parentNode.removeChild(fake);
	// 	}, 1000);
	// }, 20);

	container.appendChild(fake);

	this._fake = fake;

	return fake;
}

var _handleDispatcher = function(e) {
	if (e.type === 'page-transition:start') {
		if (!e.transitionData) {
			e.transitionData = {}
		}
		if (!e.transitionData.animation) {
			e.transitionData.animation = 'basic';
		}
		this._transitions[e.transitionData.animation].start(e.transitionData);
	}
	if (e.type === 'page-transition:end') {
		if (!e.transitionData) {
			e.transitionData = {}
		}
		if (!e.transitionData.animation) {
			e.transitionData.animation = 'basic';
		}

		import(/* webpackPrefetch: true */ '/src/assets/scripts/libs/three-r97/three.module').then((THREE) => {
			THREE.Cache.clear();
		});
		this._transitions[e.transitionData.animation].end(e.transitionData);
	}
}

elementProto.createdCallback = function() {
	this.handleDispatcher = _handleDispatcher.bind(this);
	this.copyElement = _copyElement.bind(this);
	this._transitions = {};
	this._inner = this.getElementsByClassName('inner')[0];
}
elementProto.attachedCallback = function() {
	basicTransitionDecorator.attach(this);
	menuTransitionDecorator.attach(this);
	mainTransitionDecorator.attach(this);
	//circleTransitionDecorator.attach(this);
	dispatcher.subscribe(this.handleDispatcher);
}
elementProto.detachedCallback = function() {
	basicTransitionDecorator.detach(this);
	menuTransitionDecorator.detach(this);
	mainTransitionDecorator.detach(this);
	//circleTransitionDecorator.detach(this);
	dispatcher.unsubscribe(this.handleDispatcher);
}

document.registerElement('page-transition', {
	prototype: elementProto
});
